import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import GroupIllustration from './GroupIllustration';


// To handle requests
import GroupsAPI from '../utils/GroupsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class DeleteUserFromGroupButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            modalErrorAlert: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({ showModal: false,
            modalErrorAlert: '',
        });
    }

    // Fired when modal is submitted
    submit() {
        // Launching delete users action
        const usersArrPromises = this.props.users.map(currentUser =>
            GroupsAPI.deleteUser(this.props.groupname, currentUser));

        return Promise.all(usersArrPromises).then(() => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback(this.props.groupname);
            }
        }).catch(message => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback(this.props.groupname);
            }
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
            if (message.response && message.response.body) {
                // Catch error message to display it to users
                return this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                      server returned an Internal Error.`,
                });
            }
            return undefined;
        });
    }

    render() {
        // Setting up error node in case of an error
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger" style={{ marginTop: '10px' }}>
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        return (
            <button
              className="btn btn-default
              delete-user-from-group-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-trash "></i>
                &nbsp;Remove {this.props.noSelectedLabel ? '' : 'selected'}
                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-trash"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Remove users from {this.props.groupname}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <p>
                            You are about to remove users from group
                            <strong>&nbsp;{this.props.groupname}</strong>
                        </p>
                        <hr/>
                        <GroupIllustration users={this.props.users}
                          groupname={this.props.groupname}
                          icon="ban"/>
                        {errorAlert}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.submit}>
                            Proceed
                        </button>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>

        );
    }

}

// Groupname is mandatory for delete operation to work
DeleteUserFromGroupButtonComponent.propTypes = {
    groupname: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
    callback: PropTypes.func,
    noSelectedLabel: PropTypes.bool, // Only affects button's label
};

export default DeleteUserFromGroupButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/DeleteUserFromGroupButton.js
 **/